const COLORS = ['#006AA6', '#FFCD60', '#D96383', '#BCBCBC']
export const handlePieChartData = (payload) => {
  return payload.map((item, index) => {
    return {
      ...item,
      index,
      color:
        payload.length < COLORS.length && index > 0
          ? COLORS[index + 1]
          : COLORS[index],
      value: item.numberCompanies,
      pieIndex: index,
      name: item.analysisIndicatorTypeName ?? '',
    }
  })
}
